/**
 * Shared paid-lander offer controller. The shell is intentionally identical
 * across A/B/C; this file branches only where docs/projects/mpc-lander/plan.md
 * defines a real offer difference.
 */
(function () {
  'use strict';

  var ROOT = document.getElementById('xall-lander');
  var configNode = document.querySelector('[data-xlo-config]');
  if (!ROOT || !configNode) return;

  var CONFIG;
  try { CONFIG = JSON.parse(configNode.textContent); }
  catch (error) { console.warn('[xall-paid-offer] Invalid offer configuration', error); return; }

  var offer = CONFIG.offer;
  var buybox = ROOT.querySelector('[data-xlo-buybox]');
  var scrim = ROOT.querySelector('[data-xlo-drawer-scrim]');
  var drawer = ROOT.querySelector('[data-xlo-drawer]');
  var demoScrim = ROOT.querySelector('[data-xlo-demo-scrim]');
  var demoDialog = ROOT.querySelector('[data-xlo-demo-dialog]');
  var demoVideo = ROOT.querySelector('[data-xlo-demo-video]');
  if (!buybox || !scrim || !drawer) return;

  var BASE = 1995;
  var ADDONS = ['cloths', 'toilet', 'washer'];
  var ONE_LADDERS = { B: [1995, 3495, 4495, 4995], C: [1995, 3495] };
  var SUPPLIES = {
    '90': { label: '90-Day Supply', packs: 3, tablets: 15, cadence: 'every 12 weeks', cadenceKey: '12week', tiers: [25, 30, 35], addonQty: 3, timeWord: 'refills', timeLabel: 'REFILL' },
    '30': { label: '30-Day Supply', packs: 1, tablets: 5, cadence: 'every 30 days', cadenceKey: '30day', tiers: [15, 20, 25], addonQty: 1, timeWord: 'months', timeLabel: 'MONTH' }
  };
  var state = {
    mode: 'sub', supply: '90', qty: 1, oneQty: 1,
    subAddons: { cloths: false, toilet: false, washer: false },
    oneAddons: { cloths: false, toilet: false, washer: false },
    open: false, checkoutBusy: false
  };
  var freeShippingEligible = false;
  var returnFocus = null;
  var demoReturnFocus = null;
  var demoOpen = false;
  var ATTRIBUTION_KEY = 'xall_paid_offer_attribution';
  var ATTRIBUTION_KEYS = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','gclid','fbclid','ttclid','af_source','oid','affid','sub1','sub2','sub3','sub4','sub5'];

  function cents(value) { return Math.round(value); }
  function priceFor(percent) { return cents(BASE * (1 - percent / 100)); }
  function money(value) { return '$' + (Number(value || 0) / 100).toFixed(2); }
  function countSelected(map) { return ADDONS.reduce(function (n, key) { return n + (map[key] ? 1 : 0); }, 0); }
  function text(selector, value, scope) { var node = (scope || ROOT).querySelector(selector); if (node) node.textContent = value; }
  function all(selector, scope) { return Array.prototype.slice.call((scope || ROOT).querySelectorAll(selector)); }
  function toggle(selector, show, scope) { var node = (scope || ROOT).querySelector(selector); if (node) node.hidden = !show; }

  function captureAttribution() {
    var saved = {};
    try { saved = JSON.parse(sessionStorage.getItem(ATTRIBUTION_KEY) || '{}'); } catch (error) {}
    var params = new URLSearchParams(window.location.search);
    ATTRIBUTION_KEYS.forEach(function (key) { var value = params.get(key); if (value) saved[key] = value; });
    saved.offer_id = CONFIG.offerId;
    saved.uid = CONFIG.uid;
    try { sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(saved)); } catch (error) {}
    return saved;
  }

  function attribution() {
    var saved = {};
    try { saved = JSON.parse(sessionStorage.getItem(ATTRIBUTION_KEY) || '{}'); } catch (error) {}
    saved.offer_id = CONFIG.offerId;
    saved.uid = CONFIG.uid;
    saved.landing_page = CONFIG.offerId;
    return saved;
  }

  function oneTimeDiscountPercent(value) {
    var listTotal = BASE * value.qty;
    return listTotal ? Math.round((1 - value.mpcTotal / listTotal) * 100) : 0;
  }

  function analyticsState() {
    var value = current();
    var isSub = state.mode === 'sub';
    var quantity = isSub ? value.mpcQty : value.qty;
    var discount = isSub ? value.tier : oneTimeDiscountPercent(value);
    var selectedAddons = ADDONS.filter(function (key) {
      return (isSub ? state.subAddons : state.oneAddons)[key];
    });
    return {
      offer_id: CONFIG.offerId,
      uid: CONFIG.uid,
      variant: offer,
      mode: state.mode,
      purchase_mode: isSub ? 'subscription' : 'one_time',
      supply: isSub ? (offer === 'C' ? '30' : state.supply) : 'one-time',
      quantity: quantity,
      cadence: isSub ? value.cadence : 'one-time',
      cadence_key: isSub ? value.cadenceKey : 'one-time',
      tier: discount,
      discount_pct: discount,
      value: Number((value.total / 100).toFixed(2)),
      value_cents: value.total,
      currency: 'USD',
      product_variant_id: CONFIG.products && CONFIG.products.mpc ? CONFIG.products.mpc.variantId : null,
      addon_count: selectedAddons.length,
      addons: selectedAddons
    };
  }

  function emit(name, detail) {
    // Canonical state is assigned last so stale call-site values cannot override
    // the actual selection currently rendered and sent to cart.
    var payload = Object.assign({}, attribution(), detail || {}, analyticsState());
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, payload));
    document.dispatchEvent(new CustomEvent('xall:' + name, { detail: payload }));
  }

  function subscription() {
    var selected = countSelected(state.subAddons);
    if (offer === 'C') {
      var units = state.qty + selected;
      var tier = units >= 3 ? 25 : units === 2 ? 20 : 15;
      var per = priceFor(tier);
      return {
        tier: tier, tierIndex: tier === 15 ? 0 : tier === 20 ? 1 : 2,
        per: per, mpcQty: state.qty, mpcTotal: per * state.qty,
        addonQty: 1, cadence: 'every 30 days', cadenceKey: '30day',
        tablets: state.qty * 5, supplyLabel: state.qty + ' pack' + (state.qty > 1 ? 's' : ''),
        timeWord: 'months', timeLabel: 'MONTH', total: per * units,
        tiers: [15, 20, 25], active: Math.min(units, 3) - 1,
        segmentLabels: ['1 ITEM', '2 ITEMS', '3+ ITEMS']
      };
    }
    var supply = SUPPLIES[state.supply];
    var tierIndex = Math.min(selected, 2);
    var supplyTier = supply.tiers[tierIndex];
    var supplyPer = priceFor(supplyTier);
    return {
      tier: supplyTier, tierIndex: tierIndex, per: supplyPer,
      mpcQty: supply.packs, mpcTotal: supplyPer * supply.packs,
      addonQty: supply.addonQty, cadence: supply.cadence, cadenceKey: supply.cadenceKey,
      tablets: supply.tablets, supplyLabel: supply.label,
      timeWord: supply.timeWord, timeLabel: supply.timeLabel,
      total: supplyPer * supply.packs + selected * supplyPer * supply.addonQty,
      tiers: supply.tiers, active: tierIndex,
      segmentLabels: ['BASE', '+1 ADD-ON', '+2 ADD-ONS']
    };
  }

  function oneTime() {
    var qty = offer === 'C' ? state.qty : state.oneQty;
    var ladder = ONE_LADDERS[offer] || [1995];
    var mpcTotal = ladder[qty - 1];
    var selected = countSelected(state.oneAddons);
    return { qty: qty, mpcTotal: mpcTotal, per: Math.round(mpcTotal / qty), total: mpcTotal + selected * BASE };
  }

  function current() { return state.mode === 'sub' ? subscription() : oneTime(); }

  function setSelected(nodes, attr, value) {
    nodes.forEach(function (node) {
      var selected = String(node.getAttribute(attr)) === String(value);
      node.classList.toggle('is-selected', selected);
      node.setAttribute('aria-checked', selected ? 'true' : 'false');
      node.tabIndex = selected ? 0 : -1;
    });
  }

  function directRadios(group) {
    return all('[role="radio"]', group).filter(function (node) {
      return node.closest('[role="radiogroup"]') === group;
    });
  }

  function normalizeRadioTabStops() {
    all('[role="radiogroup"]', buybox).forEach(function (group) {
      var radios = directRadios(group);
      if (!radios.length) return;
      var selected = radios.filter(function (node) {
        return node.getAttribute('aria-checked') === 'true';
      })[0] || radios[0];
      radios.forEach(function (node) { node.tabIndex = node === selected ? 0 : -1; });
    });
  }

  function renderBuybox() {
    if (offer === 'C') {
      setSelected(all('[data-xlo-qty]', buybox), 'data-xlo-qty', state.qty);
      var modePrices = state.mode === 'sub' ? [priceFor(15), priceFor(20)] : [1995, Math.round(3495 / 2)];
      text('[data-xlo="qty1-price"]', money(modePrices[0]) + ' /pack', buybox);
      text('[data-xlo="qty1-total"]', state.mode === 'sub' ? '$16.96 every 30 days' : '$19.95 billed once', buybox);
      text('[data-xlo="qty2-price"]', money(modePrices[1]) + ' /pack', buybox);
      text('[data-xlo="qty2-total"]', state.mode === 'sub' ? '$31.92 every 30 days' : '$34.95 billed once', buybox);
      text('[data-xlo="duration"]', state.qty === 1 ? 'One pack lasts about 4–6 weeks of regular cleaning.' : 'Two packs provide 10 tablets per order.', buybox);
    }

    setSelected(all('[data-xlo-supply]', buybox), 'data-xlo-supply', state.supply);
    setSelected(all('[data-xlo-one-qty]', buybox), 'data-xlo-one-qty', state.oneQty);

    if (offer !== 'A') {
      all('[data-xlo-method-card]', buybox).forEach(function (card) {
        var selected = card.getAttribute('data-xlo-method-card') === state.mode;
        card.classList.toggle('is-selected', selected);
        var head = card.querySelector('[data-xlo-mode]');
        if (head) {
          head.setAttribute('aria-checked', selected ? 'true' : 'false');
          head.tabIndex = selected ? 0 : -1;
        }
        var body = card.querySelector('[data-xlo-method-body]');
        if (body) body.hidden = !selected;
      });

      var baseSub = offer === 'C'
        ? { tier: state.qty === 2 ? 20 : 15, per: priceFor(state.qty === 2 ? 20 : 15), total: priceFor(state.qty === 2 ? 20 : 15) * state.qty, cadence: 'every 30 days' }
        : (function () { var s = SUPPLIES[state.supply]; return { tier:s.tiers[0], per:priceFor(s.tiers[0]), total:priceFor(s.tiers[0]) * s.packs, cadence:s.cadence }; })();
      text('[data-xlo="sub-unit"]', money(baseSub.per), buybox);
      text('[data-xlo="sub-badge"]', 'Save ' + baseSub.tier + '%', buybox);
      text('[data-xlo="sub-billed"]', money(baseSub.total) + ' billed ' + baseSub.cadence, buybox);
      text('[data-xlo="sub-meta"]', offer === 'B' ? 'Choose your supply · cancel anytime' : 'Delivered every 30 days · cancel anytime', buybox);

      var one = oneTime();
      text('[data-xlo="one-unit"]', money(one.per), buybox);
      text('[data-xlo="one-billed"]', money(one.mpcTotal) + ' billed once', buybox);
      text('[data-xlo="one-meta"]', offer === 'B' ? 'Choose 1–4 packs · billed once' : 'Billed once', buybox);
      if (offer === 'B') {
        ONE_LADDERS.B.forEach(function (total, index) {
          var qty = index + 1;
          text('[data-xlo="one-tier-unit-' + qty + '"]', money(Math.round(total / qty)) + '/pack', buybox);
          text('[data-xlo="one-tier-total-' + qty + '"]', money(total) + ' billed once', buybox);
        });
      }
    }

    var value = current();
    var shippingTrust = buybox.querySelector('[data-xlo="trust-shipping"]');
    if (state.mode === 'sub') {
      text('[data-xlo="buybox-disclosure"]', money(value.mpcTotal) + ' billed ' + value.cadence + ' · skip, pause or cancel anytime', buybox);
      text('[data-xlo="trust-shipping"]', '✓ Free shipping', buybox);
      if (shippingTrust) shippingTrust.hidden = false;
      text('[data-xlo-gift-timing]', value.timeWord, buybox);
      all('[data-xlo-gift-label]', buybox).forEach(function (node) {
        node.textContent = value.timeLabel + ' ' + node.getAttribute('data-xlo-gift-label');
      });
    } else {
      text('[data-xlo="buybox-disclosure"]', money(value.mpcTotal) + ' billed once · Free shipping not included', buybox);
      if (shippingTrust) shippingTrust.hidden = true;
    }
  }

  function renderSummary() {
    var summary = ROOT.querySelector('[data-xlo-summary]');
    if (!summary) return;
    var value = current();
    var isSub = state.mode === 'sub';
    var quantity = isSub ? value.mpcQty : value.qty;
    var discount = isSub ? value.tier : oneTimeDiscountPercent(value);
    var supply = isSub
      ? (offer === 'C' ? quantity + ' pack' + (quantity > 1 ? 's' : '') : value.supplyLabel)
      : quantity + ' pack' + (quantity > 1 ? 's' : '');
    var cadence = isSub ? value.cadence : 'one-time';
    var shipping = isSub ? 'Free' : (value.total >= 7500 ? 'Free' : 'Calculated at checkout');
    var selectedAddons = countSelected(isSub ? state.subAddons : state.oneAddons);
    var addonUnits = isSub ? selectedAddons * value.addonQty : selectedAddons;
    var includedValue = isSub ? 1299 + 1999 + 995 : 1299;
    var orderValue = BASE * (quantity + addonUnits) + includedValue;

    summary.setAttribute('data-xlo-summary-mode-value', state.mode);
    summary.setAttribute('data-xlo-summary-quantity-value', String(quantity));
    text('[data-xlo-summary-heading]', isSub ? 'Everything in your kit' : 'Everything in your order');
    text('[data-xlo-summary-mode]', isSub ? 'Subscribe & Save' : 'One-Time Purchase', summary);
    text('[data-xlo-summary-quantity]', String(quantity), summary);
    text('[data-xlo-summary-supply]', supply, summary);
    text('[data-xlo-summary-cadence]', cadence, summary);
    text('[data-xlo-summary-mpc-name]', quantity + '× X-ALL Tablet Pack' + (quantity > 1 ? 's' : ''), summary);
    var listPrice = BASE * quantity;
    var wasPrice = summary.querySelector('[data-xlo-summary-mpc-was]');
    if (wasPrice) {
      wasPrice.textContent = money(listPrice);
      wasPrice.hidden = value.mpcTotal >= listPrice;
    }
    text('[data-xlo-summary-mpc-price]', money(value.mpcTotal), summary);
    text('[data-xlo-summary-total]', money(value.total), summary);
    text('[data-xlo-summary-discount]', discount + '%', summary);
    text('[data-xlo-summary-shipping]', shipping, summary);
    text('[data-xlo-summary-footnote]', isSub
      ? 'Today’s kit value ' + money(orderValue) + ' — you pay ' + money(value.total) + '. Refill gifts arrive later.'
      : 'Order value ' + money(orderValue) + ' — you pay ' + money(value.total) + '. Taxes calculated at checkout.');
    all('[data-xlo-summary-sub-only]', summary).forEach(function (node) { node.hidden = !isSub; });
    all('[data-xlo-summary-one-only]', summary).forEach(function (node) { node.hidden = isSub; });
  }

  function addOnPreviewPrice(key, d, selected) {
    if (state.mode === 'one') return BASE;
    if (offer === 'C') {
      var units = d.mpcQty + countSelected(state.subAddons) + (selected ? 0 : 1);
      return priceFor(units >= 3 ? 25 : units === 2 ? 20 : 15);
    }
    var supply = SUPPLIES[state.supply];
    var selectedCount = countSelected(state.subAddons);
    var index = selected ? d.tierIndex : Math.min(selectedCount + 1, 2);
    return priceFor(supply.tiers[index]);
  }

  function renderDrawer() {
    var d = current();
    var isSub = state.mode === 'sub';
    var one = isSub ? null : d;
    var mpcQty = isSub ? d.mpcQty : one.qty;
    var tablets = mpcQty * 5;
    var cadence = isSub ? d.cadence : 'one-time';
    var packLabel = mpcQty + ' pack' + (mpcQty > 1 ? 's' : '');
    var cartMeta = isSub && offer !== 'C'
      ? d.supplyLabel + ' · ' + packLabel + ' · ' + tablets + ' tablets · ' + cadence
      : packLabel + ' · ' + tablets + ' tablets · ' + cadence;

    text('[data-xlo="cart-mpc-meta"]', cartMeta, drawer);
    text('[data-xlo="cart-mpc-price"]', money(isSub ? d.mpcTotal : one.mpcTotal), drawer);
    toggle('[data-xlo-guide-line]', isSub, drawer);
    toggle('[data-xlo-refill-note]', isSub, drawer);
    var showQtyStepper = !isSub || offer === 'C';
    toggle('[data-xlo-one-stepper]', showQtyStepper, drawer);
    if (showQtyStepper) {
      var stepQty = isSub ? d.mpcQty : one.qty;
      var stepPrice = isSub ? d.per : one.per;
      var stepMax = offer === 'B' ? 4 : 2;
      text('[data-xlo="step-qty"]', String(stepQty), drawer);
      text('[data-xlo="step-note"]', money(stepPrice) + ' per pack · 1–' + stepMax + ' packs', drawer);
      var minus = drawer.querySelector('[data-xlo-step="minus"]');
      var plus = drawer.querySelector('[data-xlo-step="plus"]');
      if (minus) minus.disabled = stepQty <= 1;
      if (plus) plus.disabled = stepQty >= stepMax;
    }
    if (!isSub) {
      text('[data-xlo="bottle-meta"]', 'Welcome gift · with your order', drawer);
    } else {
      text('[data-xlo="bottle-meta"]', 'Welcome gift · first order', drawer);
      text('[data-xlo="refill-note-text"]', 'Plus a specialist gift with each of your first 3 ' + d.timeWord + ' — Mold Stain Remover, then Garbage Disposal Cleaner, then Dishwasher Cleaner.', drawer);
    }

    toggle('[data-xlo-tier]', isSub, drawer);
    toggle('[data-xlo-shipping-progress]', !isSub, drawer);
    text('[data-xlo="drawer-eyebrow"]', isSub ? 'Build your box · optional' : 'Complete your order · optional', drawer);
    text('[data-xlo="drawer-heading"]', isSub ? 'Add more, save more.' : 'Add more for free shipping.', drawer);
    text('[data-xlo="drawer-support"]', isSub ? 'Your discount applies to every recurring item in this box.' : 'One-time add-ons ship with this order. Orders over $75 ship free.', drawer);

    if (isSub) {
      text('[data-xlo="tier-label"]', d.tier + '% off applied', drawer);
      d.tiers.forEach(function (tier, index) {
        var bar = drawer.querySelector('[data-xlo="tier-bar-' + index + '"]');
        if (bar) bar.classList.toggle('is-on', index <= d.active);
        text('[data-xlo="tier-pct-' + index + '"]', tier + '%', drawer);
        text('[data-xlo="tier-sub-' + index + '"]', d.segmentLabels[index], drawer);
      });
      var selected = countSelected(state.subAddons);
      var nudge;
      if (offer === 'C') {
        var units = d.mpcQty + selected;
        nudge = units === 1 ? 'Add 1 more item and everything drops to 20% off.' : units === 2 ? 'Add 1 more item and everything drops to 25% off.' : 'Top tier unlocked — 25% off every delivery.';
      } else {
        nudge = selected === 0 ? 'Add any add-on and your whole box drops to ' + d.tiers[1] + '% off.' : selected === 1 ? 'One more add-on unlocks ' + d.tiers[2] + '% off everything.' : 'Top tier unlocked — ' + d.tiers[2] + '% off every delivery.';
      }
      text('[data-xlo="tier-nudge"]', nudge, drawer);
    } else {
      var away = Math.max(0, 7500 - one.total);
      text('[data-xlo="shipping-progress-label"]', away > 0 ? 'You’re ' + money(away) + ' away from free shipping' : 'Free shipping unlocked', drawer);
      var progress = drawer.querySelector('[data-xlo="shipping-progress-bar"]');
      if (progress) { progress.style.width = Math.min(100, Math.round(one.total / 7500 * 100)) + '%'; progress.style.background = away > 0 ? '#1c1a17' : '#0a7d43'; }
    }

    ADDONS.forEach(function (key) {
      var selectedMap = isSub ? state.subAddons : state.oneAddons;
      var selected = !!selectedMap[key];
      var card = drawer.querySelector('[data-xlo-addon="' + key + '"]');
      var button = drawer.querySelector('[data-xlo-addon-toggle="' + key + '"]');
      if (card) card.classList.toggle('is-added', selected);
      if (button) { button.setAttribute('aria-pressed', selected ? 'true' : 'false'); button.textContent = selected ? 'Added ✓' : 'Add'; }
      var addonPrice = addOnPreviewPrice(key, d, selected);
      text('[data-xlo="addon-price-' + key + '"]', '+' + money(addonPrice) + (isSub ? ' each' : ''), drawer);
      text('[data-xlo="addon-strike-' + key + '"]', isSub ? '$19.95' : '', drawer);
      text('[data-xlo="addon-note-' + key + '"]', isSub
        ? d.addonQty + ' per delivery · ' + d.cadence
        : 'One-time · ships with this order', drawer);
    });

    text('[data-xlo="drawer-total"]', money(d.total), drawer);
    text('[data-xlo-checkout]', 'Checkout', drawer);
    text('[data-xlo="drawer-disclosure"]', isSub
      ? 'Renews ' + d.cadence + ' · cancel anytime'
      : 'Billed once', drawer);
  }

  function render() {
    renderBuybox();
    renderDrawer();
    renderSummary();
    normalizeRadioTabStops();
  }

  function isFreeShippingEligible() {
    return state.mode === 'one' && oneTime().total >= 7500;
  }

  function syncFreeShippingUnlock(allowEmit) {
    var eligible = isFreeShippingEligible();
    if (allowEmit && eligible && !freeShippingEligible) emit('free_shipping_unlocked');
    freeShippingEligible = eligible;
  }

  function setBackgroundInert(value) {
    var card = ROOT.querySelector('.xl-card');
    var sticky = ROOT.querySelector('.xl-sticky-bar');
    [card, sticky].forEach(function (node) { if (!node) return; if (value) node.setAttribute('inert', ''); else node.removeAttribute('inert'); });
  }

  function openDrawer() {
    returnFocus = document.activeElement;
    state.open = true;
    renderDrawer();
    scrim.classList.add('is-open');
    scrim.setAttribute('aria-hidden', 'false');
    document.body.classList.add('xl-scroll-lock');
    setBackgroundInert(true);
    var drawerBody = drawer.querySelector('[data-xlo-drawer-body]');
    if (drawerBody) drawerBody.scrollTop = 0;
    window.setTimeout(function () {
      if (drawerBody) drawerBody.scrollTop = 0;
      var close = drawer.querySelector('[data-xlo-close]');
      if (close) close.focus();
    }, 0);
    emit('lander_drawer_open');
  }

  function closeDrawer() {
    if (!state.open) return;
    closeDemo(false);
    state.open = false;
    scrim.classList.remove('is-open');
    scrim.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('xl-scroll-lock');
    setBackgroundInert(false);
    if (returnFocus && returnFocus.focus) returnFocus.focus();
  }

  function openDemo(trigger) {
    if (!demoScrim || !demoDialog || !demoVideo || !trigger) return;
    var src = trigger.getAttribute('data-xlo-demo-src') || '';
    if (!src) return;
    demoReturnFocus = trigger;
    demoOpen = true;
    text('[data-xlo-demo-title]', trigger.getAttribute('data-xlo-demo-title') || 'Product demonstration', demoDialog);
    text('[data-xlo-demo-desc]', trigger.getAttribute('data-xlo-demo-desc') || '', demoDialog);
    if (demoVideo.getAttribute('src') !== src) {
      demoVideo.setAttribute('src', src);
      try { demoVideo.load(); } catch (error) {}
    }
    demoVideo.muted = true;
    demoScrim.classList.add('is-open');
    demoScrim.setAttribute('aria-hidden', 'false');
    drawer.setAttribute('inert', '');
    var close = demoDialog.querySelector('[data-xlo-demo-close]');
    if (close) close.focus();
    var promise = demoVideo.play();
    if (promise && promise.catch) promise.catch(function () {});
    emit('lander_demo_open', { addon: trigger.getAttribute('data-xlo-demo') || '' });
  }

  function closeDemo(restoreFocus) {
    if (!demoOpen) return;
    demoOpen = false;
    if (demoVideo) {
      demoVideo.pause();
      try { demoVideo.currentTime = 0; } catch (error) {}
    }
    if (demoScrim) {
      demoScrim.classList.remove('is-open');
      demoScrim.setAttribute('aria-hidden', 'true');
    }
    drawer.removeAttribute('inert');
    if (restoreFocus !== false && demoReturnFocus && demoReturnFocus.focus) demoReturnFocus.focus();
    demoReturnFocus = null;
  }

  function setMode(value) {
    if (offer === 'A' || (value !== 'sub' && value !== 'one') || value === state.mode) return;
    state.mode = value;
    render();
    emit('lander_mode_select');
    syncFreeShippingUnlock(true);
  }

  function setSupply(value) {
    if (!SUPPLIES[value] || state.supply === value) return;
    state.supply = value;
    render();
    emit('lander_supply_select');
    syncFreeShippingUnlock(true);
  }

  function setQty(value) {
    value = Number(value);
    if (offer !== 'C' || (value !== 1 && value !== 2) || state.qty === value) return;
    state.qty = value;
    render();
    emit('lander_quantity_select');
    syncFreeShippingUnlock(true);
  }

  function setOneQty(value) {
    value = Number(value);
    var max = offer === 'B' ? 4 : 2;
    if (value < 1 || value > max) return;
    if (offer === 'C') state.qty = value;
    else state.oneQty = value;
    render();
    emit('lander_quantity_select');
    syncFreeShippingUnlock(true);
  }

  function toggleAddon(key) {
    if (ADDONS.indexOf(key) < 0) return;
    var map = state.mode === 'sub' ? state.subAddons : state.oneAddons;
    map[key] = !map[key];
    renderDrawer();
    renderSummary();
    emit('lander_addon_toggle', { addon: key, added: map[key] });
    syncFreeShippingUnlock(true);
  }

  function showNotice(message) { var node = drawer.querySelector('[data-xlo-checkout-notice]'); if (node) { node.textContent = message; node.classList.add('is-visible'); } }
  function hideNotice() { var node = drawer.querySelector('[data-xlo-checkout-notice]'); if (node) node.classList.remove('is-visible'); }
  function setBusy(value) {
    state.checkoutBusy = value;
    document.body.classList.toggle('xl-checkout-leaving', value);
    var button = drawer.querySelector('[data-xlo-checkout]');
    if (!button) return;
    button.disabled = value;
    button.setAttribute('aria-busy', value ? 'true' : 'false');
    if (value) { button.dataset.originalLabel = button.textContent; button.textContent = 'Redirecting to checkout…'; }
    else if (button.dataset.originalLabel) button.textContent = button.dataset.originalLabel;
  }

  function cartPayload() {
    var products = CONFIG.products || {};
    var plans = CONFIG.plans || {};
    var d = current();
    if (!products.mpc || !products.mpc.variantId || products.mpc.available === false) return { ok:false, reason:'MPC product is unavailable' };
    var items = [];
    var bonusItems = [];
    if (state.mode === 'sub') {
      var mpcPlan = plans.mpc && plans.mpc[d.cadenceKey] && plans.mpc[d.cadenceKey][d.tierIndex];
      if (!mpcPlan) return { ok:false, reason:'MPC subscription plan is unavailable' };
      items.push({ id:products.mpc.variantId, quantity:d.mpcQty, selling_plan:mpcPlan });
      for (var i = 0; i < ADDONS.length; i++) {
        var key = ADDONS[i];
        if (!state.subAddons[key]) continue;
        var product = products[key];
        var plan = plans[key] && plans[key][d.cadenceKey] && plans[key][d.cadenceKey][d.tierIndex];
        if (!product || !product.variantId || product.available === false || !plan) return { ok:false, reason:key + ' subscription option is unavailable' };
        items.push({ id:product.variantId, quantity:d.addonQty, selling_plan:plan });
      }
      ['bottle','guide'].forEach(function (key) {
        var product = products[key];
        if (!product || !product.variantId || product.available === false) return;
        var line = { id:product.variantId, quantity:1, properties:{ _xall_lander_bonus:'true', _xall_lander_offer:CONFIG.offerId, _xall_lander_bonus_name:key } };
        items.push(line); bonusItems.push(line);
      });
      if (bonusItems.length !== 2) return { ok:false, reason:'Subscription gifts are unavailable' };
    } else {
      items.push({ id:products.mpc.variantId, quantity:d.qty });
      ADDONS.forEach(function (key) {
        if (!state.oneAddons[key]) return;
        var product = products[key];
        if (product && product.variantId && product.available !== false) items.push({ id:product.variantId, quantity:1 });
      });
      for (var j = 0; j < ADDONS.length; j++) {
        if (!state.oneAddons[ADDONS[j]]) continue;
        var selectedProduct = products[ADDONS[j]];
        if (!selectedProduct || !selectedProduct.variantId || selectedProduct.available === false) return { ok:false, reason:ADDONS[j] + ' one-time option is unavailable' };
      }
      var bottle = products.bottle;
      if (!bottle || !bottle.variantId || bottle.available === false) return { ok:false, reason:'Forever Bottle gift is unavailable' };
      var bottleLine = { id:bottle.variantId, quantity:1, properties:{ _xall_lander_bonus:'true', _xall_lander_offer:CONFIG.offerId, _xall_lander_bonus_name:'bottle' } };
      items.push(bottleLine); bonusItems.push(bottleLine);
    }
    return { ok:true, items:items, bonusItems:bonusItems, derived:d };
  }

  function setCartAttributes() {
    var snapshot = analyticsState();
    var attributes = Object.assign({}, attribution(), {
      offer_variant: snapshot.variant,
      purchase_mode: snapshot.purchase_mode,
      supply: snapshot.supply,
      quantity: String(snapshot.quantity),
      cadence: snapshot.cadence,
      discount_pct: String(snapshot.discount_pct),
      offer_value: snapshot.value.toFixed(2),
      currency: snapshot.currency,
      addons: snapshot.addons.join(',')
    });
    return fetch('/cart/update.js', { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ attributes:attributes }) })
      .catch(function (error) { console.warn('[xall-paid-offer] Unable to stamp cart attribution', error); });
  }

  function redirectUrl(d) {
    var code = '';
    if (state.mode === 'sub') code = CONFIG.freeShippingCode || '';
    else if (d.qty > 1) code = (CONFIG.packCodes || {})[String(d.qty)] || '';
    return code ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout') : '/checkout';
  }

  function checkout() {
    if (state.checkoutBusy) return;
    hideNotice();
    var payload = cartPayload();
    if (!payload.ok) { console.warn('[xall-paid-offer] Checkout blocked:', payload.reason); showNotice('This offer is not ready to check out yet. Please try again shortly or contact support.'); return; }
    setBusy(true);
    fetch('/cart/clear.js', { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Unable to clear cart'); return fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' }, body:JSON.stringify({ items:payload.items }) }); })
      .then(function (response) { if (!response.ok) return response.json().then(function (body) { throw new Error(body.description || 'Unable to add offer'); }); return response.json(); })
      .then(function (cart) { return setCartAttributes().then(function () { return cart; }); })
      .then(function (cart) {
        emit('lander_checkout_click', { items:payload.items, bonusItems:payload.bonusItems, cart:cart });
        window.location = redirectUrl(payload.derived);
      })
      .catch(function (error) { console.warn('[xall-paid-offer] Checkout failed', error); showNotice('Something went wrong building your order. Please try again.'); setBusy(false); });
  }

  function trapFocus(event) {
    if (!state.open || event.key !== 'Tab') return;
    var scope = demoOpen && demoDialog ? demoDialog : drawer;
    var focusable = all('button:not([disabled]),a[href],video[controls],[tabindex]:not([tabindex="-1"])', scope).filter(function (node) { return node.offsetParent !== null; });
    if (!focusable.length) return;
    var first = focusable[0]; var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }

  function handleRadioKeydown(event) {
    if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].indexOf(event.key) < 0) return;
    var radio = event.target.closest('[role="radio"]');
    if (!radio || !buybox.contains(radio)) return;
    var group = radio.closest('[role="radiogroup"]');
    if (!group) return;
    var radios = directRadios(group).filter(function (node) {
      return !node.disabled && !node.closest('[hidden]');
    });
    if (radios.length < 2) return;
    var currentIndex = radios.indexOf(radio);
    if (currentIndex < 0) return;
    var nextIndex;
    if (event.key === 'Home') nextIndex = 0;
    else if (event.key === 'End') nextIndex = radios.length - 1;
    else {
      var increment = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : -1;
      nextIndex = (currentIndex + increment + radios.length) % radios.length;
    }
    event.preventDefault();
    radios[nextIndex].focus();
    radios[nextIndex].click();
  }

  buybox.addEventListener('click', function (event) {
    var mode = event.target.closest('[data-xlo-mode]');
    var supply = event.target.closest('[data-xlo-supply]');
    var qty = event.target.closest('[data-xlo-qty]');
    var oneQty = event.target.closest('[data-xlo-one-qty]');
    if (mode) setMode(mode.getAttribute('data-xlo-mode'));
    else if (supply) setSupply(supply.getAttribute('data-xlo-supply'));
    else if (qty) setQty(qty.getAttribute('data-xlo-qty'));
    else if (oneQty) setOneQty(oneQty.getAttribute('data-xlo-one-qty'));
    else if (event.target.closest('[data-xlo-open]')) openDrawer();
  });
  buybox.addEventListener('keydown', handleRadioKeydown);

  drawer.addEventListener('click', function (event) {
    var demo = event.target.closest('[data-xlo-demo]');
    var addon = event.target.closest('[data-xlo-addon-toggle]');
    var step = event.target.closest('[data-xlo-step]');
    if (event.target.closest('[data-xlo-close]')) closeDrawer();
    else if (demo) openDemo(demo);
    else if (addon) toggleAddon(addon.getAttribute('data-xlo-addon-toggle'));
    else if (step) {
      var delta = step.getAttribute('data-xlo-step') === 'plus' ? 1 : -1;
      if (state.mode === 'sub') setQty(state.qty + delta);
      else setOneQty(oneTime().qty + delta);
    } else if (event.target.closest('[data-xlo-checkout]')) checkout();
  });
  scrim.addEventListener('click', function (event) { if (event.target === scrim) closeDrawer(); });
  if (demoScrim) {
    demoScrim.addEventListener('click', function (event) {
      if (event.target === demoScrim || event.target.closest('[data-xlo-demo-close]')) closeDemo(true);
    });
  }
  document.addEventListener('keydown', function (event) {
    trapFocus(event);
    if (event.key !== 'Escape') return;
    if (demoOpen) closeDemo(true);
    else if (state.open) closeDrawer();
  });
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    setBusy(false);
    closeDemo(false);
    closeDrawer();
    render();
    syncFreeShippingUnlock(false);
  });

  captureAttribution();
  render();
  freeShippingEligible = isFreeShippingEligible();
  emit('lander_view');
  window.XallPaidOffer = { state:state, config:CONFIG, current:current, render:render, open:openDrawer, close:closeDrawer };
})();
